import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { QuoteQuestionsPageRoutingModule } from './quote-questions-routing.module';

import { QuoteQuestionsPage } from './quote-questions.page';
import { DatetimeModalModule } from 'src/app/components/datetime-modal/datetime-modal.module';
import { TextMaskModule } from 'angular2-text-mask';
import { AutocompleteModule } from 'src/app/components/autocomplete/autocomplete.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QuoteQuestionsPageRoutingModule,
    ReactiveFormsModule,
    DatetimeModalModule,
    TextMaskModule,
    AutocompleteModule,
  ],
  declarations: [QuoteQuestionsPage]
})
export class QuoteQuestionsPageModule {}
